import { EchartsWithTheme, Empty, useTheme } from '@maxtropy/components';
import { useRequest } from 'ahooks';
import { apiV2EnergyUnitSubordinateCostPost } from '@maxtropy/device-customer-apis-v2';
import { Spin } from 'antd';
import React, { useMemo } from 'react';
import { isEmpty, isNil } from 'lodash-es';
import { getOption } from './options';
import { DateType } from '../../prop';
import { RangeValue } from '..';
import tittleDecoration from '@/assets/images/tittleDecoration.png';
import styles from '../index.module.scss';

export interface SubordinateCostProps {
  timeResolution: DateType;
  time?: RangeValue;
  energyUnitId?: number;
  energyUnitGroupId?: number;
  energyMediumId?: string;
}

const SubordinateCost = ({
  timeResolution,
  time,
  energyMediumId,
  energyUnitGroupId,
  energyUnitId,
}: SubordinateCostProps) => {
  const theme = useTheme();

  const { data, loading } = useRequest(
    () =>
      apiV2EnergyUnitSubordinateCostPost({
        fromTime: time![0]!.valueOf(),
        toTime: time![1]!.valueOf(),
        timeResolution,
        energyUnitId,
        energyUnitGroupId,
        energyMediumId: energyMediumId === 'total' ? undefined : energyMediumId,
      }).then(res => res.list ?? []),
    {
      refreshDeps: [timeResolution, time, energyUnitId, energyUnitGroupId, energyMediumId],
      ready: !!timeResolution && !!time && !!energyMediumId && !!energyUnitId && !!energyUnitGroupId,
    }
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const options = useMemo(() => getOption(data!, timeResolution, theme), [data, theme]);

  return (
    <>
      <div className={styles.headerWrapper}>
        <img src={tittleDecoration} alt="pic" className={styles.titleBorder} />
        <span className={styles.title}>下级用能成本</span>
      </div>
      <Spin spinning={loading}>
        <EchartsWithTheme
          empty={{
            isShowEmpty: isNil(data),
            emptyNode: <Empty style={{ height: 400, paddingTop: 160 }} />,
          }}
          style={{ height: 400 }}
          theme={theme}
          option={options}
        />
      </Spin>
    </>
  );
};

export default SubordinateCost;
